<template>
  <div class="mdriveupload">
    <div v-if="showDropArea" class="overlay">
      <div class="drop-modal">
        <div class="drop-zone" @dragover.prevent @drop="onDrop">
          <img src="../../assets/images/upload.gif" />
          <div class="drop_icons_fol">
            <p>Drop files to upload them to</p>
            <div class="card-body d-flex">
              <div class="icon-small">
                <Folder />
              </div>
              <span>Folder Name</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="uploadfiles_css" v-if="showUploadSuccess || uploading || files.length">
      <h4>
        <template v-if="uploading">
          Uploading {{ files.length }} item{{ files.length > 1 ? "s" : "" }}
        </template>
        <template v-else-if="uploadSuccessFiles.length">
          {{ uploadSuccessFiles.length }} upload{{
            uploadSuccessFiles.length > 1 ? "s" : ""
          }}
          complete
        </template>
      </h4>

      <ul
        v-if="uploadSuccessFiles.length"
        class="upload-successx upload-data successclsd"
      >
        <li v-for="(file, index) in uploadSuccessFiles" :key="index">
          {{ file }}
          <svg
            class="a-s-fa-Ha-pa c-qd"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            fill="#0F9D58"
          >
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
            />
          </svg>
        </li>
      </ul>

      <ul v-if="files.length" class="upload-data">
        <li v-for="(file, index) in files" :key="index">
          {{ file.name }} ({{ file.type }}) -
          <span class="custom-spinner"></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Folder from "@/components/Widgets/Icon/Folder.vue";
import { decodeTextFromBase62, encodeTextToBase62 } from "../../utils/helper.js";

export default {
  name: "DragDropData",
  components: {
    Folder,
  },
  data() {
    return {
      mainParam: "home",
      showDropArea: false,
      dragCounter: 0,
      files: [],
      uploadSuccessFiles: [],
      uploading: false,
      showUploadSuccess: false,
      successTimer: null,
      isUploadingNow: false,
      allowedTypes: [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
        "image/svg+xml",
        "application/pdf",
        "application/zip",
        "application/x-zip-compressed",
        "application/x-rar-compressed",
        "video/mp4",
        "video/mpeg",
        "video/webm",
        "video/quicktime",
        "video/x-msvideo",
        "video/x-matroska",
        "audio/mpeg",
        "audio/mp3",
        "audio/wav",
        "audio/ogg",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ],
    };
  },
  mounted() {
    window.addEventListener("dragenter", this.onWindowDragEnter);
    window.addEventListener("dragover", this.onWindowDragOver);
    window.addEventListener("dragleave", this.onWindowDragLeave);
    window.addEventListener("drop", this.onDrop);
  },
  beforeUnmount() {
    window.removeEventListener("dragenter", this.onWindowDragEnter);
    window.removeEventListener("dragover", this.onWindowDragOver);
    window.removeEventListener("dragleave", this.onWindowDragLeave);
    window.removeEventListener("drop", this.onDrop);
    clearTimeout(this.successTimer);
  },
  methods: {
    encodeTextToBase62,
    decodeTextFromBase62,

    onWindowDragEnter(e) {
      e.preventDefault();
      if (this.$store.state.isModalImgOpen === 1) {
        this.dragCounter++;
      }
    },
    onWindowDragOver(e) {
      e.preventDefault();
      if (this.$store.state.isModalImgOpen !== 1) return;
      const items = e.dataTransfer.items;
      this.showDropArea = Array.from(items).some(
        (item) => item.kind === "file" && this.allowedTypes.includes(item.type)
      );
    },
    onWindowDragLeave(e) {
      e.preventDefault();
      this.dragCounter--;
      if (this.dragCounter <= 0) {
        this.showDropArea = false;
      }
    },
    onDrop(e) {
      e.preventDefault();
      this.dragCounter = 0;
      this.showDropArea = false;

      const droppedFiles = Array.from(e.dataTransfer.files);
      const fileIdSet = new Set();
      const validFiles = [];

      for (let file of droppedFiles) {
        const fileId = `${file.name}-${file.size}-${file.lastModified}`;
        if (this.allowedTypes.includes(file.type) && !fileIdSet.has(fileId)) {
          fileIdSet.add(fileId);
          validFiles.push(file);
        }
      }

      if (validFiles.length < droppedFiles.length) {
        alert("Some files were rejected or duplicated.");
      }

      this.files = validFiles;

      if (this.files.length > 0) {
        this.fileUpload();
      }
    },
    cancelUpload() {
      this.files = [];
      this.uploading = false;
      this.showUploadSuccess = false;
      this.uploadSuccessFiles = [];
      clearTimeout(this.successTimer);
    },
    async fileUpload() {
      if (this.isUploadingNow) return;
      this.isUploadingNow = true;

      let Folderpaths = "";
      if (this.$route.query.path && this.$route.query.path.trim() !== "") {
        const pathSegments = this.$route.query.path.split("/");
        Folderpaths = pathSegments
          .map((segment) => this.decodeTextFromBase62(segment))
          .join("/");
      }
      if (Folderpaths === "/") Folderpaths = "";

      this.uploading = true;
      this.showUploadSuccess = false;
      clearTimeout(this.successTimer);

      while (this.files.length > 0) {
        const file = this.files[0];
        const _URL = process.env.VUE_APP_API_URL + "files/upload-to-folder";
        let formData = new FormData();
        formData.append("file", file);
        formData.append("folderName", Folderpaths);

        try {
          const resp = await axios.post(_URL, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          if (resp.status === 200 && resp.data.status === "success") {
            this.$toast.success(resp.data.message);
            if (!this.uploadSuccessFiles.includes(file.name)) {
              this.uploadSuccessFiles.push(file.name);
            }
            //  this.$store.state.home.tableFolderLoader = Math.random();
            
          } else {
            console.error(resp.data.message || "Upload failed");
          }
        } catch (error) {
          console.error(`Error uploading ${file.name}:`, error);
        }

        this.files.shift();
      }

      this.uploading = false;
      this.isUploadingNow = false;
      this.showUploadSuccess = true;

      this.$store.state.home.reLoadFilecomponent = Math.random();
       this.$store.state.home.tableFileLoader = Math.random();

      this.successTimer = setTimeout(() => {
        this.showUploadSuccess = false;
        this.uploadSuccessFiles = [];
      }, 30000);
    },
  },
};
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(80, 80, 80, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.drop-modal {
  background: white;
  padding: 30px;
  border-radius: 10px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  text-align: center;
}
.drop-zone {
  border: 2px dashed #00f;
  padding: 40px;
  margin: 20px 0;
  border-radius: 10px;
  background-color: #f0f8ff;
  transition: background-color 0.3s;
}
.custom-spinner {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  border: 2px solid #ccc;
  border-top-color: #007bff;
  border-radius: 50%;
  animation: spinner 0.6s linear infinite;
  vertical-align: middle;
  margin-right: 5px;
}
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}
.upload-success {
  margin-top: 20px;
  padding: 10px;
  background: #e7f9ec;
  border: 1px solid #b6e1c7;
  border-radius: 5px;
  color: #2e7d32;
}
</style>
